<div class="header">
<h2>Najczęściej zadawane pytania</h2>
<button (click)="closeMe.emit()" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>
